import { FunctionComponent, JSX } from 'react'
import { useRouter } from 'next/router'
import { useAuthenticationStatus } from '@nhost/nextjs'

type RedirectTarget = string | ((router: ReturnType<typeof useRouter>) => string)

export function redirectAnonymousUsers<T extends JSX.IntrinsicAttributes>(
  WrappedComponent: FunctionComponent<T>,
  redirectTo: RedirectTarget = '/',
) {
  return function RedirectAnonymousUsers(props: T) {
    const { isAuthenticated } = useAuthenticationStatus()
    const router = useRouter()

    if (!isAuthenticated) {
      const redirectPath = typeof redirectTo === 'function' ? redirectTo(router) : redirectTo
      router.push(redirectPath)
      return null
    }

    return <WrappedComponent {...props} />
  }
}

// Redirect authenticated users to home page from login page
export function redirectAuthedUsers<T extends JSX.IntrinsicAttributes>(
  WrappedComponent: FunctionComponent<T>,
  redirectTo = '/',
) {
  return function RedirectAuthedUsers(props: T) {
    const { isAuthenticated } = useAuthenticationStatus()
    const router = useRouter()

    if (isAuthenticated) {
      if (redirectTo === '/') router.push(redirectTo)
      else
        router.push({
          pathname: redirectTo,
          query: router.query,
        })
      return null
    }

    return <WrappedComponent {...props} />
  }
}
